import {
  Flex,
  Button,
  Stack,
  Box,
  Image,
  useBreakpointValue,
  InputGroup,
  InputLeftElement,
  Text,
} from "@chakra-ui/react";
import logo from "../../assets/logos/PNG/logo_horizontal_verde_branco.png";
import mobileLogo from "../../assets/logos/PNG/logo_verde_branco2.png";
import { Icon } from "@chakra-ui/react";
import { FiMail, FiLock } from "react-icons/fi";
import { Link } from "react-router-dom";
import * as yup from "yup";

import { Input } from "../../components/ControlledInput";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from "../../hooks/auth";
import { yupResolver } from "@hookform/resolvers/yup";

type SignInFormData = {
  email: string;

  password: string;
};

const signInFormSchema = yup.object().shape({
  email: yup
    .string()
    .required("E-mail é obrigatório")
    .email("O formato do e-mail é inválido"),
  password: yup.string().required("A senha é obrigatória").trim(),
});

export default function SignIn() {
  const { signIn } = useAuth();
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(signInFormSchema),
  });
  const { errors } = formState;

  const handleSignIn: SubmitHandler<SignInFormData> = async (values) => {
    const { email, password } = values;

    try {
      await signIn({
        email: email,
        password: password,
      });

      // history.push("/instructions");
    } catch (error: any) {
      const { message } = error.response.data;
      // toast.error(message);
    }
  };

  return (
    <Flex
      w="100vw"
      h="100vh"
      align="center"
      justify="center"
      bg="bg"
      direction={isWideVersion ? "row" : "column"}
    >
      {isWideVersion ? (
        <Box w="100%">
          <Image
            h="64vh"
            src={logo}
            alt=""
            objectFit="cover"
            objectPosition="center"
          />
        </Box>
      ) : (
        <Box>
          <Image
            h="18vh"
            mt="5"
            src={mobileLogo}
            alt=""
            objectFit="cover"
            objectPosition="center"
          />
        </Box>
      )}

      <Flex w="100%" h="100vh" align="center" justify="center">
        <Flex
          width="100%"
          maxWidth={360}
          bg="bg"
          p="8"
          borderRadius={8}
          flexDirection="column"
          backgroundColor="#32363c"
          as="form"
          //@ts-ignore
          onSubmit={handleSubmit(handleSignIn)}
        >
          <Text fontSize="3xl" fontWeight="bold" color="#ffffff">
            Olá,
          </Text>
          <Text fontSize="lg" mb="5" color="#ffffff">
            Bem-vindo(a) de volta!
          </Text>
          <Stack spacing={4}>
            <Input
              //@ts-ignore
              name="email"
              type="email"
              icon={FiMail}
              placeholder="E-mail"
              {...register("email")}
            />
            <Input
              //@ts-ignore
              name="password"
              type="password"
              icon={FiLock}
              placeholder="Senha"
              {...register("password")}
            />
          </Stack>

          <Text
            fontSize="12"
            mt="2"
            display="flex"
            flexDirection="row-reverse"
            cursor="pointer"
            color="text"
          >
            Esqueceu a senha?
          </Text>

          <Button
            mt="6"
            borderRadius={30}
            colorScheme="green_primary"
            size="lg"
            bg="green_primary"
            color="black"
            type="submit"
            isLoading={formState.isSubmitting}
          >
            Entrar
          </Button>

          <Text
            fontSize="14"
            color="#ffffff"
            mt="6"
            display="flex"
            justifyContent="center"
            cursor="pointer"
          >
            Cadastre-se
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
